import { useEffect, useState } from 'react';
import { Shell } from './components/Layout';
import { Home } from './pages/Home';
import { Planner } from './pages/Planner';
import { Admin } from './pages/Admin';

export default function App() {
  const [route, setRoute] = useState(() => window.location.pathname === '/admin' ? 'admin' : window.location.pathname === '/plan' ? 'plan' : 'home');

  useEffect(() => {
    const onPop = () => setRoute(window.location.pathname === '/admin' ? 'admin' : window.location.pathname === '/plan' ? 'plan' : 'home');
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  function start() {
    history.pushState({}, '', '/plan');
    setRoute('plan');
    window.scrollTo(0, 0);
  }

  function home() {
    history.pushState({}, '', '/');
    setRoute('home');
    window.scrollTo(0, 0);
  }

  return (
    <Shell>
      {route === 'admin' ? <Admin /> : route === 'plan' ? <Planner onBack={home} /> : <Home onStart={start} />}
    </Shell>
  );
}
